import { render, staticRenderFns } from "./PaymentPurchaseWidget.vue?vue&type=template&id=857a176e&scoped=true"
import script from "./PaymentPurchaseWidget.vue?vue&type=script&lang=js"
export * from "./PaymentPurchaseWidget.vue?vue&type=script&lang=js"
import style0 from "./PaymentPurchaseWidget.vue?vue&type=style&index=0&id=857a176e&prod&lang=scss"
import style1 from "./PaymentPurchaseWidget.vue?vue&type=style&index=1&id=857a176e&prod&lang=scss&scoped=true"
import style2 from "./PaymentPurchaseWidget.vue?vue&type=style&index=2&id=857a176e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857a176e",
  null
  
)

export default component.exports